import { axiosEstimates } from '../../../utils';
import { GetBudget, GetBudgetData, GetDocumentsByBudget, Document } from '../models';

export async function getBudget(id: string): Promise<GetBudgetData> {
  const response = await axiosEstimates.get<GetBudget>('/v2/budget/' + id);
  return response.data.data;
}

/**
 * Documentos de carga de una cotización. El personal va con sesión; el cliente que entra por el
 * enlace de su correo manda el token de esa cotización (x-invoice-token).
 */
export async function getDocumentsByBudget(id: string, invoiceToken?: string): Promise<Document[]> {
  const response = await axiosEstimates.get<GetDocumentsByBudget>('/api/document/' + id, {
    headers: invoiceToken ? { 'x-invoice-token': invoiceToken } : undefined,
  });

  return response.data.data;
}
